import React from "react";
import {Cascader, Form, Input, InputNumber, Radio, Switch} from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHFetch from "../../../utils/NHFetch";
import map from '../../../styles/images/map.png';
import jiaotong from '../../../styles/images/jiaotong.png';
import fengjing from '../../../styles/images/fengjing.png';
import tongzhi from '../../../styles/images/tongzhi.png';

const RadioGroup = Radio.Group;

class AddOrEditForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            inputFlag: false,
            options: [],   //级联下拉数据
            flbzArr: [],
            updateFlag: false,
            ljdzShowFlag: true,
            ljdzUpdateFlag: true,
        }
    }

    static defaultProps = {
        initData: {
            pkid: '',
            ljmc: '',
            ljdz: '',
            ljtp: '',
            pxh: 1,
            zt: '0',
            ljlx: '2',
            kjcs: '',
            flbz: ''
        }
    };

    //初始加载级联下拉数据
    componentDidMount() {
        this.getInitXxfbfl();
        if (this.props.initData.ljlx === '1') {
            this.setState({
                updateFlag: true,
                ljdzShowFlag: false,
                ljdzUpdateFlag: false
            })
        } else {
            this.setState({
                ljdzUpdateFlag: true
            });
        }
        if (this.props.initData.flbz) {
            this.getParentsByXxfbflbz(this.props.initData.flbz);
        }
    }

    getParentsByXxfbflbz = (flbz) => {
        NHFetch('/fwwgl/sylj/getParentsByFbflbz', "GET", {flbz: flbz})
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        flbzArr: res.data
                    });
                }
            });
    };

    //获取信息发布分类信息
    getInitXxfbfl = () => {
        NHFetch('/fwwgl/sylj/getXxfbflInfo', 'GET', {})
            .then(res => {
                if (res) {
                    this.setState({
                        options: res.data
                    })
                }
            });
    };

    onChange = (e) => {
        let value = e.target.value;
        this.setState({
            inputFlag: value === '1',
            value: value,
            updateFlag: value === '1',
            ljdzShowFlag: value !== '1',
            ljdzUpdateFlag: value !== '1',
        });
    };

    getXxfbflbzArr = () => {
        let flbzArr = this.state.flbzArr;
        let arr = [];
        for (let i = flbzArr.length - 1; i >= 0; i--) {
            let xxfbfl = flbzArr[i];
            arr.push(xxfbfl.flbz);
        }
        return arr;
    };

    render() {
        const form = this.props.form;
        const initData = this.props.initData;
        let arr = this.getXxfbflbzArr();

        return (
            <div>
                <Form layout="horizontal">
                    <NHFormItem id={'ljmc'} label={'链接名称'} hasFeedback={true} form={form} required={true}
                                pattern={{max: 100, message: "链接名称长度不能超过100字符！"}}
                                initialValue={initData.ljmc}>
                        <Input placeholder="请输入链接名称"/>
                    </NHFormItem>
                    <NHFormItem id={'ljlx'} label={'链接类型'} form={form} required={true}
                                initialValue={initData.ljlx ? initData.ljlx : '2'}>
                        <RadioGroup onChange={this.onChange}>
                            <Radio value={'2'}>完整链接</Radio>
                            <Radio value={'1'}>信息发布</Radio>
                        </RadioGroup>
                    </NHFormItem>
                    <div style={{display: (this.state.ljdzShowFlag || this.state.ljdzUpdateFlag) ? "block" : "none"}}>
                        <NHFormItem id={'ljdz'} label={'链接地址'} hasFeedback={true} form={form}
                                    pattern={{max: 300, message: "链接地址长度不能超过300字符！"}}
                                    initialValue={initData.ljdz}>
                            <Input placeholder="请输入链接地址"/>
                        </NHFormItem>
                    </div>
                    <div style={{display: (this.state.inputFlag || this.state.updateFlag) ? "block" : "none"}}>
                        <NHFormItem id={'flbz'} label={'信息发布分类'} form={form}
                                    initialValue={initData.flbz ? arr : []}>
                            <Cascader options={this.state.options} placeholder="请选择信息发布分类"/>
                        </NHFormItem>
                    </div>
                    <NHFormItem id={'ljtp'} label={'链接图片'} form={form} required={true}
                                initialValue={initData.ljtp ? initData.ljtp : ''}>
                        <RadioGroup>
                            <Radio value={'fengjing.png'}>
                                <img style={{maxWidth: 40, maxHeight: 40}} src={fengjing}/>
                            </Radio>
                            <Radio value={'jiaotong.png'}>
                                <img style={{maxWidth: 40, maxHeight: 40}} src={jiaotong}/>
                            </Radio>
                            <Radio value={'map.png'}>
                                <img style={{maxWidth: 40, maxHeight: 40}} src={map}/>
                            </Radio>
                            <Radio value={'tongzhi.png'}>
                                <img style={{maxWidth: 40, maxHeight: 40}} src={tongzhi}/>
                            </Radio>
                        </RadioGroup>
                    </NHFormItem>
                    <NHFormItem id={'pxh'} label={'排序号'} hasFeedback={true} form={form}
                                initialValue={initData.pxh ? initData.pxh : 1}>
                        <InputNumber min={1} max={999999}/>
                    </NHFormItem>
                    <NHFormItem id={'zt'} label={'状态'} form={form} valuePropName={'checked'}
                                initialValue={initData.zt ? (initData.zt === '启用') : true}>
                        <Switch checkedChildren="启用" unCheckedChildren="停用"/>
                    </NHFormItem>
                </Form>

            </div>
        );
    }
}

const addOrEditForm = Form.create()(AddOrEditForm);

export default addOrEditForm;



// WEBPACK FOOTER //
// ./components/fwwgl/sylj/AddOrEditForm.js